export const blockWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: 0,
};

export const blockHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};
